import App from "../../../App"
import RewardDialog from "../../../component/visible/RewardDialog"
import Message from '../../../../class/Message'
import SingleOfferTemplate from "../../../component/template/SingleOfferTemplate"
import i18nTools from '../../../../common/local/format'

export default class rewardPlusDialog extends SingleOfferTemplate {
  constructor(...props) {
    super(...props)
  }

  initComponents() {
    super.initComponents()
    // 在传入关闭按钮点击事件时，需根据当前弹窗是否收回，写对应逻辑
    // 在传入立即观看点击事件时，需根据当前弹窗是否收回，写对应逻辑
    // 点击跳转的时候加载loading，给.reward-plus-dialog-container 添加.reward-click  class
    // 收缩：给 .reward-plus-dialog-container 给增加.reward-close
    // 展开：去掉.reward-close
    // 收回来的webview宽度 改为220
    this.rpDialog = new RewardDialog({
      imageUrl: App.initData.unitSetting.icon,
      buttonText: i18nTools.formatByUA('_next_reward_button'),
      rewardContent: i18nTools.formatByUA('_next_reward_text'),
      onButtonClick: () => {
        const sendData = {
          instanceId: App.rootWebviewId,
          campaign: this.campaign,
        }
        Message.emitMessageToSuperView('onInstallBtnClick', sendData)
        console.log("reward plus button点击")
      },
      onCloseBtnClick: () => {
        const sendData = {
          instanceId: App.rootWebviewId,
          campaign: this.campaign,
        }
        Message.emitMessageToSuperView('onCloseBtnClick', sendData)
        console.log("关闭按钮点击")
      },
    })
    this.rpDialog.appendTo(document.querySelector('.page-container'))
  }

  bindEvent() {
    super.bindEvent()
    Message.onSuperViewEmitMessage('shrinkDialog', () => {
      document.querySelector('.reward-plus-dialog-container').classList.add('reward-close')
    })

    Message.onSuperViewEmitMessage('expandDialog', () => {
      document.querySelector('.reward-plus-dialog-container').classList.remove('reward-close')
    })

    Message.onSuperViewEmitMessage('waitNextOfferReady', () => {
      document.querySelector('.reward-plus-dialog-container').classList.add('reward-click')
    })

    Message.onSuperViewEmitMessage('setRewardNumber', (data) => {
      console.log("###setRewardNumber")
      console.log("###收到大模版传值rewardAmount",data.rewardAmount)
      this.rpDialog.setRewardNumber(Math.floor(data.rewardAmount).toFixed())
      // endcard webviewshow之后再初始化文案布局
      setTimeout(()=>{
        console.log("###准备初始化文字和按钮布局")
        this.rpDialog.initContent()
      },1010)
    })
  }

  /**
   * 销毁组件
   */
  destory() {
    super.destory()
  }

  /**
   * 子类需要重写该方法，以判断模板的是否成功加载
   * @returns {Promise}
   */
  _isLoadFinish() {
    return super._isLoadFinish()
  }
}